import React from 'react'
import Nav from '../Nav'
import Team from '../sections/Team'

export default function TeamsPage() {
  return (
    <div>
      <Nav />
      <Team />
    </div>
  )
}
